import FlavourConfig from '../../../../shared/config/flavours';
import Pages from '../../../../shared/types/enums/pages';
import TAccess from '../../templates/access';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { clearStack } from '../../../../shared/store/slices/router.slice';
import { pushRoute } from '../../../../shared/store/thunks/route.thunk';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useEffect } from 'react';
import DeviceConfig from '@devices/config';

function Welcome() {
  const dispatch = useAppDispatch();
  const buttonText = TranslationManager.get('PAGES.ACCESS.WELCOME.BUTTON');
  const description = TranslationManager.get(
    `PAGES.ACCESS.WELCOME.${FlavourConfig.specialLiterals.WELCOME_DESCRIPTION}`,
    FlavourConfig.appTitle
  );
  const title = TranslationManager.get(
    'PAGES.ACCESS.WELCOME.TITLE',
    FlavourConfig.appTitle
  );

  const action = () => {
    if (FlavourConfig.languages.length > 1) {
      dispatch(
        pushRoute({ route: { Page: Pages.LANGUAGES, overwrite: true } })
      );
    } else {
      dispatch(pushRoute({ route: { Page: Pages.LINK, overwrite: true } }));
    }
  };

  useEffect(() => {
    dispatch(clearStack());
  }, []);

  return (
    <TAccess
      title={title}
      description={description}
      buttonText={buttonText}
      action={action}
      returnAction={DeviceConfig.exit}
    />
  );
}

export default Welcome;
